import React from 'react';
import ContainerTemplate from '../../../widgets/template/Container';
import MateriasDocentesView from './MateriasDocentesView';
import * as ROUTES from '../../../router/Routes';

const MateriasDocentesModule = () => {
  return (
    <ContainerTemplate active={ROUTES.materias} routes={[ROUTES.academico]}>
      <MateriasDocentesView />
    </ContainerTemplate>
  );
};

export default MateriasDocentesModule;
